import React from "react";

import "./Footer.scss";

import iconCall from "../../images/icon/icon-call.png";
import iconKr from "../../images/icon/icon_KR.png";
import iconCn from "../../images/icon/icon_CN.png";
import iconJp from "../../images/icon/icon_JP.png";
import iconUs from "../../images/icon/icon_US.png";

export default function Footer() {
  return (
    <div className="footer">
      <div className="footer-call">호출</div>
      <div className="footer-sco">
        <div className="footer-left">
          <img src={iconCall} alt="icon-call" />
        </div>
        <div className="footer-right">
          <img src={iconKr} alt="icon-KR" />
          <img src={iconCn} alt="icon-CN" />
          <img src={iconJp} alt="icon-JP" />
          <img src={iconUs} alt="icon-US" />
        </div>
      </div>
    </div>
  );
}
